<template>
  <div class="shipAddress">
    <div class="title">
      <span class="cur_pointer">收货地址</span>
    </div>
    <div class="form_box">
      <el-form :model="dataForm" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="地址信息" prop="place">
          <cascader-city ref="casCity" :GetProList="GetProList" :GetDisList="GetDisList" :GetTownList="GetTownList" @getEndPlace="getEndPlace"></cascader-city>
        </el-form-item>
        <el-form-item label="详细地址" prop="detailAddr">
          <el-input v-model="dataForm.detailAddr" type="textarea" resize="none" :maxlength="120" show-word-limit :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入详细地址信息，如道路、门牌号、 小区、楼栋号、单元等信息"></el-input>
        </el-form-item>
        <el-form-item label="收货人姓名" prop="deliveryPerson">
          <el-input v-model="dataForm.deliveryPerson" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="telNo">
          <el-input v-model="dataForm.telNo" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item prop="isDefault">
          <el-checkbox v-model="dataForm.isDefault" :true-label="1" :false-label="0">默认地址</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary btn" @click="updateAddr" v-if="dataForm.id.length>0">确定修改</el-button>
          <el-button type="primary btn" @click="addAddr" v-else>新增收货地址</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tab_box">
      <div class="header">
        <span>
          已保存
          <span>{{tableData.length}}</span>了条地址，还能保存
          <span>{{20-tableData.length}}</span>条地址
        </span>
      </div>
      <el-table :data="tableData" style="width: 100%" :border="true">
        <el-table-column prop="deliveryPerson" label="收货人" align="center" width="156"></el-table-column>
        <el-table-column prop="place" label="所在地区" align="center" width="300" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="detailAddr" label="详细地址" align="center" width="300" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="telNo" label="电话/手机" align="center"></el-table-column>
        <el-table-column label="操作" align="center" class-name="action">
          <template slot-scope="scope">
            <div class="item com_link" :class="localRowId == scope.row.id?'active':''" @click="updateAddrAction(scope.row)">修改</div>
            <div class="item com_link" @click="delAddr(scope.row.id)">删除</div>
          </template>
        </el-table-column>
        <el-table-column align="center" class-name="default_box">
          <template slot-scope="scope">
            <span class="default" v-show="scope.row.isDefault===1">默认地址</span>
            <span class="noDefault com_link" v-show="scope.row.isDefault===0" @click="setDefault(scope.row.id)">设为默认地址</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import CascaderCity from "@/components/cascaderCity";
import { validatetypeName, checkMobile } from "@/pages/publicUtils/validate";
export default {
  metaInfo: { title: "收货地址 - 个人中心" },
  name: "shipAddress",
  components: {
    CascaderCity,
  },
  props: {
    GetAddrList: {
      type: Function,
      default: () => {},
    },
    AddAddress: {
      type: Function,
      default: () => {},
    },
    UpdateAddress: {
      type: Function,
      default: () => {},
    },
    DelAddress: {
      type: Function,
      default: () => {},
    },
    SetDefaultAddress: {
      type: Function,
      default: () => {},
    },
    GetProList: {
      type: Function,
      default: () => {},
    },
    GetDisList: {
      type: Function,
      default: () => {},
    },
    GetTownList: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    let checkName = (rule, value, callback) => {
      // console.log(value, validatetypeName(value));
      if (!value) {
        return callback(new Error("必填"));
      }
      if (value.length < 2 || value.length > 12) {
        return callback(new Error("最少2个最多12个字符"));
      }
      if (!validatetypeName(value)) {
        return callback(new Error("请输入中文或英文姓名"));
      }
      callback();
    };
    return {
      dataForm: {
        id: "",
        place: "",
        detailAddr: "",
        deliveryPerson: "",
        telNo: "",
        isDefault: 0,
        provinceCode: "",
        cityCode: "",
        disCode: "",
        townId: "",
        provinceName: "",
        cityName: "",
        disName: "",
        townName: "",
      },
      rules: {
        place: [{ required: true, message: "必选", trigger: "change" }],
        detailAddr: [{ required: true, message: "必填", trigger: "blur" }],
        deliveryPerson: [
          { validator: checkName, required: true, trigger: "blur" },
        ],
        telNo: [{ validator: checkMobile, required: true, trigger: "blur" }],
      },
      pageInfo: {
        pageNumber: 1,
        pageSize: 20,
        searchProperty: [
          {
            searchFiled: "",
            searchValue: "",
          },
        ],
        orderProperty: [],
      },
      tableData: [],
      localRowId: "",
    };
  },
  mounted() {
    this.getAddrList();
  },
  methods: {
    getAddrList() {
      this.GetAddrList({ pageInfo: this.pageInfo }).then((res) => {
        // console.log("获取地址列表", res);
        this.tableData = res.data;
        this.tableData.forEach((v) => {
          v.place =
            v.provinceName +
            " " +
            v.cityName +
            " " +
            v.disName +
            " " +
            v.townName;
        });
      });
    },
    addAddr() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.AddAddress(this.dataForm).then((res) => {
            // console.log("新增地址接口", res);
            this.clearFormData();
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.getAddrList();
          });
        } else {
          return false;
        }
      });
    },
    updateAddrAction(item) {
      // console.log(item);
      this.localRowId = item.id;
      this.dataForm = {
        id: item.id,
        place: "回填的值",
        deliveryPerson: item.deliveryPerson,
        detailAddr: item.detailAddr,
        telNo: item.telNo,
        isDefault: item.isDefault,
        provinceCode: item.provinceCode,
        cityCode: item.cityCode,
        disCode: item.disCode,
        townId: item.townId,
        provinceName: item.provinceName,
        cityName: item.cityName,
        disName: item.disName,
        townName: item.townName,
      };
      let codeArr = [
        item.provinceCode,
        item.cityCode,
        item.disCode,
        item.townId,
      ];
      this.$refs.form.resetFields();
      this.$refs.casCity.setValue(codeArr);
    },
    updateAddr() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.UpdateAddress(this.dataForm).then((res) => {
            // console.log("修改地址", res);
            this.clearFormData();
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getAddrList();
          });
        } else {
          return false;
        }
      });
    },
    delAddr(id) {
      this.$confirm("此操作会永久删除地址, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.DelAddress({ id }).then((res) => {
            // console.log("删除接口", res);
            this.getAddrList();
          });
        })
        .catch(() => {});
    },
    setDefault(id) {
      this.$confirm("此操作会改变默认地址, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.SetDefaultAddress({ id }).then((res) => {
            // console.log("设置默认地址", res);
            this.getAddrList();
          });
        })
        .catch(() => {});
    },
    getEndPlace(val) {
      if (val.label.length == 0) {
        this.dataForm.place = "";
      } else {
        this.dataForm.place = "赋值满足要求";
      }
      this.dataForm.provinceCode = val.value[0];
      this.dataForm.cityCode = val.value[1];
      this.dataForm.disCode = val.value[2];
      this.dataForm.townId = val.value[3];
      this.dataForm.provinceName = val.label[0];
      this.dataForm.cityName = val.label[1];
      this.dataForm.disName = val.label[2];
      this.dataForm.townName = val.label[3];
      // console.log(val,this.dataForm);
    },
    clearFormData() {
      this.$refs.form.resetFields();
      for (const key in this.dataForm) {
        this.dataForm[key] = "";
      }
      this.localRowId = "";
      this.$refs.casCity.value = [];
    },
  },
};
</script>

<style lang="less" scoped>
.shipAddress {
  .title {
    height: 40px;
    line-height: 40px;
    padding: 0px 31px;
    background: rgba(244, 244, 244, 1);
  }
  .form_box {
    height: 420px;
    box-sizing: border-box;
    border: 1px solid rgba(244, 244, 244, 1);
    margin-top: 14px;
    padding: 38px 0 0 100px;
    /deep/ .el-form {
      .el-form-item {
        margin-bottom: 30px;
        .el-form-item__label {
          line-height: 24px;
          color: #000000;
        }
        .el-form-item__content {
          line-height: 24px;
          width: 260px;
          .el-input {
            .el-input__inner {
              height: 24px;
              line-height: 24px;
            }
          }
          .btn {
            border-radius: 0px;
          }
          .el-form-item__error {
            color: @themeColor;
          }
        }
      }
    }
  }
  .tab_box {
    margin-top: 14px;
    margin-bottom: 80px;
    .header {
      height: 40px;
      background: rgba(244, 244, 244, 1);
      line-height: 40px;
      padding-left: 26px;
      font-size: 14px;
      font-weight: 400;
    }
    /deep/ .el-table {
      .el-table__header-wrapper {
        .cell {
          color: #606266;
          font-weight: 400;
        }
      }
      .el-table__body-wrapper {
        .cell {
          color: #000000;
          font-weight: 400;
        }
        .action {
          .cell {
            display: flex;
            .item {
              width: 50%;
            }
            .active {
              color: @themeColor;
            }
          }
        }
        .default_box {
          .default {
            color: @themeColor;
          }
        }
      }
    }
  }
}
</style>